import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Label from "./Label";
import DatePicker, { registerLocale } from "react-datepicker";
import { fr } from "date-fns/locale";
import {
  validationMode,
  validationClass,
  isInvalidClass,
} from "./CpntFormFieldGroup";
import { formatDate_fns } from "../../utils/helpers";
registerLocale("fr", fr);

interface IProps {
  label?: string;
  formName: string;
  maxDate?: Date;
  minDate?: Date;
  placeholder?: string;
  ismandatory?: boolean;
  popover?: string;
  validationStyle?: validationMode;
  extraOnChange?: (val: Date) => void; // Type le callback d'`extraOnChange` pour accepter un objet `Date`
  setValue?: (name: string, value: Date | null) => void; // Typage de `setValue` pour accepter des objets `Date` ou `null`
  getValue?: (name: string) => Date | null; // Typage de `getValue` pour retourner un objet `Date` ou `null`
  error?: string;
  showTimeSelect?: boolean;
  showMonthYear?:boolean;
  disabled?: boolean;
}
const DatePickerInput: React.FC<IProps> = ({
  formName,
  label = formName,
  maxDate,
  minDate,
  ismandatory,
  placeholder,
  popover,
  validationStyle = validationMode.classic,
  extraOnChange,
  setValue,
  error,
  disabled,
  showTimeSelect = false,
  showMonthYear = false,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { getFieldState, control, getValues,register } = useFormContext();

  const validationClassName = (): string => {
    switch (validationStyle) {
      case validationMode.classic:
        return validationClass(
          getFieldState(formName).error || error,
          (!getFieldState(formName).error || error) &&
            getValues(formName) !== "DEFAULT"
        );
      case validationMode.invalid:
        return isInvalidClass(getFieldState(formName).error || error);
      default:
        return "";
        break;
    }
  };

  return (
    <Label
      label={label}
      htmlFor={formName}
      errors={getFieldState(formName).error?.message || error}
      ismandatory={ismandatory}
      popover={popover}
    >
      <Controller
        // name={formName}
        control={control}
        {...register(formName)}
        render={({ field }) => (
          <DatePicker
            showTimeSelect={showTimeSelect}
            showMonthYearPicker = {showMonthYear}
            showFullMonthYearPicker = {showMonthYear}
            selected={field.value}
            onChange={(e) => {
              field.onChange(e);
              extraOnChange && e && extraOnChange(e);
              setValue && setValue(formName, e);
            }}
            //dateFormat="dd/MM/yyyy"
            dateFormat={showTimeSelect? "Pp" : formatDate_fns}
            maxDate={maxDate}
            minDate={minDate}
            locale="fr"
            autoComplete="off"
            placeholderText={placeholder}
            className={`form-control ${validationClassName()}`}
            disabled={disabled}
          />
        )}
      />
    </Label>
  );
};

export default DatePickerInput;
